import { Card, CardBody, CardHeader, Colors, Icon, Text } from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';
import {
    CYCLE_CARD_SURFACE_BG_COLOR,
    CYCLE_CARD_SURFACE_BORDER_COLOR,
    CYCLE_SECTION_SURFACE,
} from '@/pages/CycleEvaluation/components/cycleCardSurface';

export interface CycleFrameCardProps {
    cycleName: string;
    periodLabel: string;
    resolvedEmployeeCount: number;
}

const FrameStat = ({
    label,
    value,
    icon,
}: {
    label: string;
    value: string;
    icon?: React.ReactNode;
}) => (
    <div>
        <Text
            color={Colors.STEP_RAIL_MUTED}
            className={
                'mb-[4px] flex items-center gap-[6px] text-xs font-bold tracking-wider uppercase'
            }
        >
            {icon}
            {label}
        </Text>

        <Text
            weight={'semibold'}
            color={Colors.SLATE}
        >
            {value}
        </Text>
    </div>
);

export const CycleFrameCard = ({
    cycleName,
    periodLabel,
    resolvedEmployeeCount,
}: CycleFrameCardProps) => {
    const { t } = useAmelioTranslations();

    return (
        <Card
            padding={'none'}
            className={CYCLE_SECTION_SURFACE}
            bgColor={CYCLE_CARD_SURFACE_BG_COLOR}
            borderColor={CYCLE_CARD_SURFACE_BORDER_COLOR}
            dataTestId={'launch-summary-frame'}
        >
            <CardHeader
                icon={
                    <Icon
                        name={'time-calendar'}
                        color={Colors.STEP_RAIL_TURQUOISE}
                        size={16}
                    />
                }
                title={t('cycleEvaluationSchedule.launchSummary.frame.title')}
            />

            <CardBody>
                <div className={'responsive-grid-1-3-sm gap-4'}>
                    <FrameStat
                        label={t('cycleEvaluationSchedule.launchSummary.frame.name')}
                        value={cycleName || '—'}
                    />

                    <FrameStat
                        label={t('cycleEvaluationSchedule.launchSummary.frame.period')}
                        value={periodLabel}
                    />

                    <FrameStat
                        icon={
                            <Icon
                                name={'users-profile-2user'}
                                color={Colors.STEP_RAIL_MUTED}
                                size={12}
                            />
                        }
                        label={t('cycleEvaluationSchedule.launchSummary.frame.audience')}
                        value={t('cycleEvaluationSchedule.launchSummary.frame.audienceCount', {
                            count: resolvedEmployeeCount,
                        })}
                    />
                </div>
            </CardBody>
        </Card>
    );
};
